/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ExecRiskApiAppCoreModelsScansIRS990ProgSrvcAccomActy
 */
export interface ExecRiskApiAppCoreModelsScansIRS990ProgSrvcAccomActy {
    /**
     * 
     * @type {string}
     * @memberof ExecRiskApiAppCoreModelsScansIRS990ProgSrvcAccomActy
     */
    activity_cd?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskApiAppCoreModelsScansIRS990ProgSrvcAccomActy
     */
    expense_amt?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskApiAppCoreModelsScansIRS990ProgSrvcAccomActy
     */
    grant_amt?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskApiAppCoreModelsScansIRS990ProgSrvcAccomActy
     */
    revenue_amt?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskApiAppCoreModelsScansIRS990ProgSrvcAccomActy
     */
    desc?: string;
}

/**
 * Check if a given object implements the ExecRiskApiAppCoreModelsScansIRS990ProgSrvcAccomActy interface.
 */
export function instanceOfExecRiskApiAppCoreModelsScansIRS990ProgSrvcAccomActy(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ExecRiskApiAppCoreModelsScansIRS990ProgSrvcAccomActyFromJSON(json: any): ExecRiskApiAppCoreModelsScansIRS990ProgSrvcAccomActy {
    return ExecRiskApiAppCoreModelsScansIRS990ProgSrvcAccomActyFromJSONTyped(json, false);
}

export function ExecRiskApiAppCoreModelsScansIRS990ProgSrvcAccomActyFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExecRiskApiAppCoreModelsScansIRS990ProgSrvcAccomActy {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'activity_cd': !exists(json, 'activity_cd') ? undefined : json['activity_cd'],
        'expense_amt': !exists(json, 'expense_amt') ? undefined : json['expense_amt'],
        'grant_amt': !exists(json, 'grant_amt') ? undefined : json['grant_amt'],
        'revenue_amt': !exists(json, 'revenue_amt') ? undefined : json['revenue_amt'],
        'desc': !exists(json, 'desc') ? undefined : json['desc'],
    };
}

export function ExecRiskApiAppCoreModelsScansIRS990ProgSrvcAccomActyToJSON(value?: ExecRiskApiAppCoreModelsScansIRS990ProgSrvcAccomActy | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'activity_cd': value.activity_cd,
        'expense_amt': value.expense_amt,
        'grant_amt': value.grant_amt,
        'revenue_amt': value.revenue_amt,
        'desc': value.desc,
    };
}

